import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { Mail } from "lucide-react";
import { useEffect, useState } from "react";
import { useGetMyInvitations } from "../../api/hooks";
import { useInvitationsModalTrigger } from "../../hooks/use-invitations-modal-trigger";
import { InvitationsModal } from "../modals/invitations-modal/invitations-modal";

export const InvitationTrigger = () => {
  const [showInvitations, setShowInvitations] = useState(false);
  const { data: invitations } = useGetMyInvitations();
  const invitationCount = invitations.count ?? 0;

  // Automatically show modal on new browser sessions with pending invitations
  const { shouldShow, onOpenChange } = useInvitationsModalTrigger();

  // Sync the auto-trigger with the local state
  useEffect(() => {
    if (shouldShow && !showInvitations) {
      setShowInvitations(true);
    }
  }, [shouldShow, showInvitations]);

  const handleOpenChange = (open: boolean) => {
    setShowInvitations(open);
    onOpenChange(open);
  };

  if (invitationCount === 0) {
    return null;
  }

  return (
    <>
      <Button
        aria-label="Invitations"
        className="relative"
        onClick={() => setShowInvitations(true)}
        size="icon"
        variant="secondary"
      >
        <Mail className="h-5 w-5" />
        {invitationCount > 0 && (
          <span className="absolute top-2 right-2 flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-orange-400 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-orange-600" />
          </span>
        )}
      </Button>

      <InvitationsModal
        onOpenChange={handleOpenChange}
        open={showInvitations}
      />
    </>
  );
};
